import type { AdminSection } from '../types';
import { ADMIN_NAV_ITEMS } from '../types';

interface AdminSidebarProps {
  active: AdminSection;
  onSelect: (section: AdminSection) => void;
  onLogout: () => void;
  open: boolean;
  onToggle: () => void;
}

export default function AdminSidebar({ active, onSelect, onLogout, open, onToggle }: AdminSidebarProps) {
  return (
    <aside
      className={`fixed top-0 left-0 h-full bg-white border-r border-gray-100 transition-all duration-300 z-20 flex flex-col ${
        open ? 'w-64' : 'w-16'
      }`}
    >
      {/* Logo */}
      <div className="flex items-center gap-3 px-4 py-5 border-b border-gray-100 overflow-hidden">
        <div className="w-9 h-9 flex-shrink-0 flex items-center justify-center bg-gradient-to-br from-orange-500 to-yellow-400 rounded-xl">
          <i className="ri-shield-keyhole-fill text-white text-base"></i>
        </div>
        {open && (
          <div className="flex-1 min-w-0">
            <div className="text-sm font-bold text-gray-800 whitespace-nowrap truncate">Admin Panel</div>
            <div className="text-xs text-gray-400 whitespace-nowrap truncate">Bahnar Games</div>
          </div>
        )}
        <button
          onClick={onToggle}
          className={`w-7 h-7 flex items-center justify-center rounded-lg hover:bg-gray-50 text-gray-400 cursor-pointer flex-shrink-0 transition-all ${
            open ? '' : 'mx-auto'
          }`}
        >
          <i className={`${open ? 'ri-arrow-left-s-line' : 'ri-arrow-right-s-line'} text-lg`}></i>
        </button>
      </div>

      {/* Nav */}
      <nav className="flex-1 py-4 px-2 space-y-1 overflow-y-auto">
        {ADMIN_NAV_ITEMS.map((item) => (
          <button
            key={item.id}
            onClick={() => onSelect(item.id)}
            title={!open ? item.label : undefined}
            className={`w-full flex items-center gap-3 px-3 py-2.5 rounded-xl transition-all cursor-pointer ${
              active === item.id
                ? 'bg-orange-50 text-orange-500'
                : 'text-gray-500 hover:bg-gray-50 hover:text-gray-700'
            }`}
          >
            <div className="w-5 h-5 flex items-center justify-center flex-shrink-0">
              <i className={`${item.icon} text-base`}></i>
            </div>
            {open && (
              <span className="text-sm font-medium whitespace-nowrap">{item.label}</span>
            )}
          </button>
        ))}
      </nav>

      {/* Bottom */}
      <div className="p-2 border-t border-gray-100 space-y-1">
        <a
          href="/"
          target="_blank"
          rel="noopener noreferrer"
          title={!open ? 'Xem website' : undefined}
          className="w-full flex items-center gap-3 px-3 py-2.5 rounded-xl text-gray-400 hover:bg-gray-50 hover:text-gray-600 transition-all cursor-pointer"
        >
          <div className="w-5 h-5 flex items-center justify-center flex-shrink-0">
            <i className="ri-external-link-line text-base"></i>
          </div>
          {open && <span className="text-sm font-medium whitespace-nowrap">Xem website</span>}
        </a>
        <button
          onClick={onLogout}
          title={!open ? 'Đăng xuất' : undefined}
          className="w-full flex items-center gap-3 px-3 py-2.5 rounded-xl text-red-400 hover:bg-red-50 transition-all cursor-pointer"
        >
          <div className="w-5 h-5 flex items-center justify-center flex-shrink-0">
            <i className="ri-logout-box-r-line text-base"></i>
          </div>
          {open && <span className="text-sm font-medium whitespace-nowrap">Đăng xuất</span>}
        </button>
      </div>
    </aside>
  );
}
